export const validateEmail = (email: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!email) return resolve();

    const emailRegex = /^(?!.*\s)([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,63})$/;
    const invalidCharRegex = /[^a-zA-Z0-9._%+-]/;
    if (/^\s|\s$/.test(email)) {
      return reject('Email không được chứa khoảng trắng ở đầu và cuối!');
    } else if (!emailRegex.test(email)) {
      return reject('Email không đúng định dạng!');
    }

    const [localPart, domain] = email.split('@');
    if (!/^[a-zA-Z0-9._-]+$/.test(localPart)) {
      return reject('Local-Part không hợp lệ!');
    }

    if (!/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/.test(domain)) {
      return reject('Tên miền không hợp lệ!');
    }

    if ((domain.match(/\./g) || []).length > 2) {
      return reject('Domain không được chứa quá 2 dấu chấm!');
    }

    if (invalidCharRegex.test(domain)) {
      return reject('Tên miền không được chứa ký tự đặc biệt!');
    }

    return resolve();
  });
};
